// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 474) return "static/chunks/fe69a73d-c3b7044e6d94cdf9.js";
	if (chunkId === 3038) return "static/chunks/3038-4c677d9f84ba04b1.js";
	if (chunkId === 7339) return "static/chunks/7339-7da3a945403099d2.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 5119 ? "eebbe23b" : chunkId) + "." + {"1135":"21fb1c84d3f85e1f","1544":"231f10aca9850344","1618":"039ef5d9993eaed3","1798":"8af44401ead2a905","3445":"63d69946cf7e0c66","5119":"20b75bc1f313846c","8021":"abff9ad88116da5c","8351":"23bf7a2390b3d4ad"}[chunkId] + ".js";
};